import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [isNotification, setIsNotification] = useState(false);

  const toggleNotificationTrue = () => {
    setIsNotification(true);
  };
  const toggleNotificationFalse = () => {
    setIsNotification(false);
  };

  return (
    <NotificationContext.Provider value={{ isNotification, toggleNotificationTrue,toggleNotificationFalse }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
